<template>
	<span style="display:flex">
	   <a-form-model-item>
	      <downloadexcel
	      	class="ant-btn ant-btn-primary export-btn"
		:fetch="getdatasource"
		:fields="excelheader"
		:before-finish="exportsuccess"
		name="本页数据.xls"
	      >导出本页数据</downloadexcel>
	   </a-form-model-item>
	   <a-form-model-item>
	      <downloadexcel
	      	class="ant-btn ant-btn-primary export-btn"
		:fields="excelheader"
		:fetch="getAllData"
		:before-finish="exportsuccess"
		name="全部数据.xls"
	      >导出全部数据</downloadexcel>
	   </a-form-model-item>
	</span>
</template>
<script>
import downloadexcel from "vue-json-excel";
import {message} from "ant-design-vue"
import {cailiaoexport} from "@/api/cailiaodan.js"
let user = sessionStorage.getItem("userinfo")
user = JSON.parse(user)
const  excelheader ={
	"合同名称":"name",
	"合同类型":{
		field:"type",
		callback:(value)=>{
			let types = new Map([['1',"班组结算单"],["2","个人结算单"],["3","工资预支单"],["4","扫码登记"],["5","电子合同"],["6","报销单"]])
			return types.get(value)||""
		}
	},
	"合同金额":"price",
	"签署日期":"yiDate",
	"乙方姓名":"yi",
	"乙方电话":"yiPhone",
	"乙方所在工地":"yiWorkPlace",
	"所属班组":"yiBanZhu",
	"是否拨款":{
		callback:(val)=>{
			let {type,isMoneyGive} = val
			if(type != 4){
				return val==0?"未拨款":"已拨款"
			}
			return ""
		}
	},
	"在场情况":{
		callback:(val)=>{
			let {type,yiOuttime} = val
			if(type == 4){
			    return yiOuttime ?"离场":"在场"
			}
			return ""
		}
	}
}


export default {
	components:{
           downloadexcel
	},
	props:[
	    "getpagedata",'getsearchdata'
	],
	data(){
		return {
		    excelheader,
		}
	},
	methods:{
        getdatasource(){
	      message.loading({content:"正在导出",key:"daochu"})
	      return this.getpagedata()
	},
	exportsuccess(){
            message.success({content:"导出成功",key:"daochu",duration:2})
	},
	async getAllData(){
        message.loading({content:"正在导出",key:"daochu"})
	    let parm = this.getsearchdata 
	    let {code,data} = await cailiaoexport({...parm,cmpid:user.cmpid})
	    if(code == 0){
		    return data
	    }
	    return false
	},
	}
}
</script>
<style lang="less" scoped>
    .export-btn{
	    line-height: 30px ;
    }
</style>



